import { OutlinedInputProps, TextField } from "@mui/material";
import { CSSProperties } from "react";

const TexBoxWithLabel = ({
  size,
  label,
  style,
  value,
  placeholder,
  fullWidth,
  onChange,
  row,
  maxRow,
  defaultValue,
  multiline = false,
  types,
  restrictDigits,
  restrictToFourDigits = false,
}: TexBoxWithLabelProps) => {
  const handleInputChange = (event: any) => {
    if (restrictToFourDigits && types === "number") {
      const inputValue = event.target.value.replace(/\D/g, "");
      if (restrictDigits !== undefined && inputValue.length > restrictDigits) {
        return;
      }
      event.target.value = inputValue;
    }
    onChange && onChange(event);
  };
  return (
    <div
      style={{
        ...style,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TextField
        placeholder={placeholder}
        id="outlined-basic"
        variant="outlined"
        type={"number"}
        label={label}
        fullWidth={fullWidth}
        sx={{ width: "100%" }}
        size={size}
        value={value}
        onChange={handleInputChange}
        defaultValue={defaultValue}
        rows={row}
        maxRows={types === "number" ? undefined : row}
        multiline={multiline}
        inputProps={{
          maxLength:
            restrictToFourDigits && types === "number"
              ? restrictDigits
              : undefined,
        }}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </div>
  );
};

export default TexBoxWithLabel;

interface TexBoxWithLabelProps {
  size: "small" | "medium";
  placeholder: string;
  label: string;
  style?: CSSProperties | undefined;
  onChange?: OutlinedInputProps["onChange"];
  value?: any;
  fullWidth?: boolean;
  row?: number;
  maxRow?: number;
  multiline?: boolean;
  defaultValue?: string;
  types?: string;
  restrictToFourDigits?: boolean;
  restrictDigits?: number;
}
